import React, { Component } from 'react';
import { connect } from 'react-redux';
import { AssessmentContainer, AssessmentNavigation } from './common';
import { assessmentStatus } from '../../Constants';

class AssessmentEnd extends Component {
	constructor(props) {
		super(props);

		this.handleBack = this.handleBack.bind(this);
		this.handleNext = this.handleNext.bind(this);
	}

	componentDidMount() {
		const {
			versionID,
			userData,
			setTermination,
			setAssessmentStatus,
			saveScreenDuration,
			save
		} = this.props;

		const { username, tests } = userData;
		const testIndex = tests.findIndex(test => test.versionNum === versionID);
		tests[testIndex].isCompleted = 1;
		setAssessmentStatus(assessmentStatus.Complete);
		saveScreenDuration();
		// save({
		// 	username,
		// 	testName: tests[testIndex].fullName,
		// 	value: 1
		// });
	}

	handleBack() {
		const {
			versionID,
			userData,
			setTermination,
			setUserData,
			setAssessmentStatus,
			saveScreenDuration,
			save,
			history,
			previousLink
		} = this.props;

		const { username, tests } = userData;
		const testIndex = tests.findIndex(test => test.versionNum === versionID);
		tests[testIndex].isCompleted = 0;
		setAssessmentStatus(assessmentStatus.InProgress);
		saveScreenDuration();
		save({
			username,
			testName: tests[testIndex].fullName,
			value: 0
		});
		history.push(previousLink);
	}

	handleNext() {
		const { history, nextLink } = this.props;
		history.push(nextLink);
	}

	render() {
		return (
			<AssessmentContainer>
				<AssessmentNavigation type="end_back" onClick={this.handleBack} />
				<AssessmentNavigation type="end_next" onClick={this.handleNext} />
			</AssessmentContainer>
		);
	}
}

const mapStateToProps = state => ({
	versionID: state.data.versionID,
	userData: state.data.userData
});

export default connect(mapStateToProps, null)(AssessmentEnd);